import Hero from "@/components/home/Hero";
import ShopByCategory from "@/components/home/ShopByCategory";
import FeaturedProducts from "@/components/home/FeaturedProducts";
import Collections from "@/components/home/Collections";
import TrustBadges from "@/components/home/TrustBadges";
import CustomerReviews from "@/components/home/CustomerReviews";
import Newsletter from "@/components/home/Newsletter";

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <main>
        <Hero />
        <ShopByCategory />
        <FeaturedProducts />
        <Collections />
        <TrustBadges />
        <CustomerReviews />
        <Newsletter />
      </main>
    </div>
  );
}
